import { useEffect, useState } from 'react';

/**
 * Returns `value` debounced by `delayMs` — updates only after the input has
 * stopped changing for that long. Use for search boxes / filters so each
 * keystroke doesn't fire a request.
 *
 * The timer resets on every `value` change and is cleared on unmount, so a
 * pending update never lands after the component is gone.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
